module.exports = __webpack_public_path__ + "static/media/YF76_01.5d1d9b30.jpg";